// extracted by mini-css-extract-plugin
export default {"title-section":"s2nqYeUSNWIAZxQILN7G","view-section-box":"EzU8HWEDtlUFEQJgroJy","info-item":"nm8EJ5NR4iM17hrBwlTz","info-label":"IjAJ1ksbZeImU13o3kYg"};